interface VerticalSpacerProps {
    children: number
}

function VerticalSpacer(props: VerticalSpacerProps) {
    return <div style={{ height: props.children }} className={"w-full"} />
}

export default VerticalSpacer
